var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.pageClass + _vm.setClass, attrs: { id: "app" } },
    [
      _vm.loading
        ? [_c("Loader", { attrs: { fullPage: "" } })]
        : [
            _vm.logged && _vm.permisos !== false && !_vm.IsFormPage
              ? _c("navbar", {
                  ref: "navbar",
                  attrs: { permisos: _vm.permisos },
                  on: {
                    newComercial: _vm.newComercial,
                    toggleGoogle: _vm.toggleGoogle,
                    toggleKmz: _vm.toggleKmz,
                    draw: function($event) {
                      _vm.drawFlag = !_vm.drawFlag
                    },
                    potential: function($event) {
                      _vm.showPotentialFlag = !_vm.showPotentialFlag
                    }
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.drawFlag
              ? [
                  _vm.showPotentialFlag
                    ? _c("drawarea", {
                        ref: "drawAreaPotential",
                        on: {
                          accept: _vm.showPotentialResults,
                          cancel: _vm.hidePotential,
                          add: _vm.addPolygon,
                          select: _vm.selectArea
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.drawAreaLotes
                    ? _c("drawarea", {
                        ref: "drawAreaLotes",
                        attrs: { view: _vm.drawAreaLotesView },
                        on: {
                          accept: _vm.acceptLotes,
                          cancel: _vm.cancelLotes,
                          add: _vm.addPolygon,
                          select: _vm.selectArea
                        }
                      })
                    : _vm._e()
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.logged && !_vm.IsFormPage
              ? _c("Tools", {
                  ref: "tools",
                  on: {
                    showInfo: function($event) {
                      _vm.infoFlag = !_vm.infoFlag
                    },
                    showStreet: function($event) {
                      _vm.streetFlag = !_vm.streetFlag
                    },
                    close: _vm.closeInfo,
                    draw: function($event) {
                      _vm.drawDistance = !_vm.drawDistance
                    }
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.logged
              ? _c("StreetView", {
                  ref: "streetview",
                  on: { close: _vm.closeInfo }
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "main", attrs: { id: "content" } },
              [
                _c("router-view", {
                  attrs: {
                    infoFlag: _vm.infoFlag,
                    streetFlag: _vm.streetFlag,
                    user_id: _vm.user_id
                  }
                }),
                _vm._v(" "),
                _vm.showPopUp && _vm.logged
                  ? _c("PopUp", {
                      attrs: {
                        clickEvent: _vm.clickEvent,
                        ComercialTypes: _vm.ComercialTypes,
                        permisos: _vm.permisos,
                        selectarea: _vm.isSelectArea
                      },
                      on: {
                        calderaSaved: _vm.calderaSaved,
                        comercialSaved: _vm.comercialSaved,
                        changeLocation: _vm.changeLocation,
                        getLocation: _vm.getLocation,
                        setLocation: _vm.setLocation,
                        clickFeature: _vm.clickFeature,
                        hide: _vm.hidePopUp,
                        selectedArea: _vm.addSelectedArea
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.showComercioGoogle && _vm.logged
                  ? _c("GoogleTooltip", {
                      attrs: {
                        comercial: _vm.comercioGoogle,
                        permisos: _vm.permisos
                      },
                      on: {
                        setLocation: _vm.setLocation,
                        hide: function($event) {
                          _vm.showComercioGoogle = false
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.newComercialFlag && _vm.logged
                  ? _c(
                      "div",
                      { staticClass: "mapButtons" },
                      [
                        _c(
                          "b-button",
                          { on: { click: _vm.cancelMapButtons } },
                          [_vm._v("Cancelar")]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          { on: { click: _vm.saveComercialPos } },
                          [_vm._v("Guardar")]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.logged
                  ? _c(
                      "div",
                      {
                        staticClass: "popstyle",
                        style: { display: _vm.parsedLocalizado }
                      },
                      [
                        _c(
                          "b-modal",
                          {
                            ref: "myModal",
                            staticClass: "fixedModal",
                            attrs: {
                              size: "lg",
                              id: "modal1",
                              title: "Comercial",
                              centered: "",
                              "hide-footer": true
                            },
                            on: { hidden: _vm.cancelMapButtons }
                          },
                          [
                            _c("Details", {
                              ref: "details",
                              attrs: {
                                feature: _vm.details,
                                permisos: _vm.permisos
                              },
                              on: { close: _vm.closeNewComercial }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            !_vm.logged || _vm.IsFormPage
              ? _c("div", { staticClass: "push" })
              : _vm._e(),
            _vm._v(" "),
            !_vm.logged || _vm.IsFormPage ? _c("VueFooter") : _vm._e(),
            _vm._v(" "),
            _c("SuccessAlert"),
            _vm._v(" "),
            _c("ErrorAlert"),
            _vm._v(" "),
            _c("WarningAlert"),
            _vm._v(" "),
            _c("nprogress-container")
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/App.vue?vue&type=template&id=7ba5bd90&
// module id = null
// module chunks = 